import {Injectable} from '@angular/core';
import {Mapper} from '../../../core/abstracts/mapper.abstract';
import {ReportFormValue} from '../model/report-form.model';
import {ReportVehicleDetails} from '../model/report-item-details.model';
import {Brand} from '../../entities/brand/models/brand.model';
import {VehicleModel} from '../../entities/model/model/vehicle-model.model';
import {VehicleStorage} from '../../entities/storage/model/storage.model';
import {VehicleCategory} from '../../entities/category/models/vehicle-category.model';
import {Owner} from '../../entities/owners/models/owner.model';
import {toIsoDateTimeHelper} from '../../../core/helpers/to-iso-date-time.helper';

@Injectable({providedIn: 'root'})
export class ReportVehicleDetailsMapper extends Mapper<ReportFormValue, ReportVehicleDetails> {

  override map(source: ReportFormValue): ReportVehicleDetails {
    return new ReportVehicleDetails(
      this.resolveBrands(source.vehicleDetailsSection.brands),
      this.resolveModels(source.vehicleDetailsSection.models),
      source.vehicleDetailsSection.vins,
      source.vehicleDetailsSection.registrationPlates,
      source.vehicleDetailsSection.factoryNumbers,
      this.resolveCategories(source.vehicleDetailsSection.categories),
      this.resolveOwnerIds(source.vehicleDetailsSection.owners),
      this.resolveStoragesIds(source.vehicleDetailsSection.storages),
      source.vehicleDetailsSection.returningPersons,
      toIsoDateTimeHelper(source.vehicleTimetablesSection.arrivalDateFrom),
      toIsoDateTimeHelper(source.vehicleTimetablesSection.arrivalDateTo),
      toIsoDateTimeHelper(source.vehicleTimetablesSection.releaseDateFrom),
      toIsoDateTimeHelper(source.vehicleTimetablesSection.releaseDateTo),
      source.vehicleDetailsSection.receivers,
      source.vehicleDocumentSection.keyNumbers,
      source.vehicleDocumentSection.documentNumbers,
      source.vehicleDocumentSection.archiveNumbers
    )
  }

  private resolveBrands(brands: Brand[]): string[] {
    return brands?.map(brand => brand.name);
  }

  private resolveModels(models: VehicleModel[]): string[] {
    return models?.map(model => model.name);
  }

  private resolveCategories(categories: VehicleCategory[]): string[] {
    return categories?.map(category => category.category);
  }

  private resolveOwnerIds(owners: Owner[]): number[] {
    return owners?.map(owner => owner.id);
  }

  private resolveStoragesIds(storages: VehicleStorage[]): number[] {
    return storages?.map(storage => storage.id);
  }
}
